import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Vuex from 'vuex'
import {getWeikeQuestions} from '@/apps/h5/model/api'


@Component({ components: {} })
export default class QuestionVenus extends Vue {
    public isStored = false
    public config: any

    public async getWeikeQuestions() {
        const Venus = (window as any).Venus
        const { data } = await getWeikeQuestions({}, {})
        
        this.config = {
            container: '#container',
            framework: {
              vue: Vue,
              vuex: Vuex
            },
            questionList: data,
            getQuestionRemote: false,
            showCommitBtn: true,
            showFinishBtn: true,
            fetchQuestion: null,
            autoPlayAudio: false,
            onCommit: (qobj) => {
              Venus.getAnswerResult('local', true).then(async res => {
                const { id, token } = this.$route.query
                const options = {
                  token,
                  course_id: id,
                  action: 'ANSWER_QUES',
                  question_id: qobj.id,
                  q_answer: res[qobj.id].master ? 1 : 0
                }
      
                // await report(options)
              })
            },
            onFinish: (list) => {
                window.location.reload()
            }
        }
        // 初始化
        console.log(Venus)
        Venus.init(this.config)
    }

    public mounted() {
        try {
            this.getWeikeQuestions()
        } catch(e) {
            setTimeout(() => {
                this.getWeikeQuestions()
            }, 50)
        }
    }
}